import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';
import { Subscription } from 'rxjs';
import { AuthService } from 'src/app/modules/core/auth/services/auth.service';
import { Role, UserAttrs } from 'src/app/modules/core/types';
@Component({
    selector: 'app-sidebar-left',
    templateUrl: './sidebar-left.component.html',
    styleUrls: ['./sidebar-left.component.scss'],
})
export class SideBarLeftComponent implements OnInit, OnDestroy {
    userAttrs?: UserAttrs;
    sub: Subscription = new Subscription();
    constructor(private dialog: MatDialog, private authService: AuthService, private domSanitizer: DomSanitizer,) {
        this.userAttrs = this.authService.userAttrs;
    }

    get isSuperAdmin() {
        return this.userAttrs?.role === Role.SUPER_ADMIN;
    }

    get isSimuAdmin() {
        return this.userAttrs?.role === Role.SIMU_ADMIN;
    }

    get isOrgAdmin() {
        return this.userAttrs?.role === Role.ORG_ADMIN;
    }

    ngOnInit(): void {
        this.sub = this.authService.updateProfileEvent.subscribe(() => {
            this.userAttrs = this.authService.userAttrs;
        });
    }
    ngOnDestroy(): void {
        this.sub.unsubscribe();
    }

    closeAllDialog() {
        this.dialog.closeAll();
    }

    get getImage() {
        if (this.userAttrs?.picture) {
            return this.domSanitizer.bypassSecurityTrustUrl(this.userAttrs.picture);
        }
        return '';
    }
}
